import React from "react";
import  { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';

const styles = theme => ({
    root: {
      padding:0,
      verticalAlign: "middle",
      height: "100%",
      width: 30,
      alignSelf: "center",
      color: theme.gridIconBorderColor,
      '&$checked': {
        color: theme.HeaderSelectedText
      }
    },
    checked: {
        color:theme.HeaderSelectedText
    }
  });

class RadioRenderer extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            checked: Boolean(this.props.value)
        }
    }

    componentDidUpdate(prevProps){
      //  console.log("PrevProps", prevProps);
    }

    refresh(params){
        this.setState({
            checked:Boolean(params.value)
        });
        return true;
    }

    render(){
        const { classes } = this.props;
        const { field } = this.props.colDef || {};
        return(
            <Radio
                checked={this.state.checked}
                onChange={(event, checked)=> this.props.node.setDataValue(field,checked)}
                value="a"
                name="isActive"
                aria-label="A"
                color="primary"
                disabled={this.props.disabled}
                classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
            />
        )
    }
}

export default withStyles(styles)(RadioRenderer);